export default [
    {
        path: '/sptjm',
        redirect: '/sptjm',
        name: 'sptjm',
        component: () => import('@/views/NestedRoute.vue'),
        children: [
            {
                path: '',
                name: 'sptjmIndex',
                component: () => import('@/views/sptjm/Index.vue'),
                meta: {
                    action: 'Lihat',
                    resource: 'sptjm',
                    pageTitle: 'Surat Pertanggungjawaban Mutlak',
                    breadcrumb: [
                        {
                            text: 'Surat Pertanggungjawaban Mutlak',
                            active: true,
                        },
                    ],
                },
            },
        ]
    }
]